import { Modal } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

export interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive,
  loading,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={title || t("confirm")}
      onClose={onClose}
      primaryAction={{
        content: confirmLabel || t("Yes"),
        onAction: onConfirm,
        destructive: !!destructive,
        loading: !!loading,
      }}
      secondaryActions={[
        {
          content: cancelLabel || t("No"),
          onAction: onClose,
          disabled: !!loading,
        },
      ]}
    >
      <Modal.Section>
        <p style={{ whiteSpace: "pre-line" }}>{message}</p>
      </Modal.Section>
    </Modal>
  );
}
